// Curated starter list of feed topics (v1 of feed personalization).
// Selections are stored per-user (user.feedTopics); the feed algorithm that
// consumes them lands in a later phase — extend/edit freely.
export const FEED_TOPICS = [
  'Gaming',
  'Sports',
  'Technology',
  'Music',
  'Movies & TV',
  'News',
  'Science',
  'Food',
  'Travel',
  'Fitness',
  'Art & Design',
  'Fashion',
  'Business',
  'Memes',
  'Anime',
  'Books',
  'Photography',
  'Cars',
] as const;

export type FeedTopic = (typeof FEED_TOPICS)[number];
